import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    q: "How much does a contractor website cost in Colorado?",
    a: "A real, lead-generating contractor website in Colorado typically runs $4,500–$12,000 depending on scope (number of pages, custom design, integrations). We publish full pricing on our pricing page so you can compare apples-to-apples — no hidden fees.",
  },
  {
    q: "What should a contractor website include to get more leads?",
    a: "A fast mobile experience, sticky click-to-call, a short quote-request form on every service page, real photo galleries, financing or estimate CTAs, social proof (reviews + jobsite photos), and clean local SEO. We build every contractor site to those standards.",
  },
  {
    q: "How long does it take to build a contractor website?",
    a: "Most of our contractor builds launch in 4–6 weeks from kickoff. Larger or custom builds can run 6–10 weeks. We move fast because we don't outsource design or dev — it's done in-house at our Colorado Springs office.",
  },
  {
    q: "Do I own my website after it's built by Colorado Web Impressions?",
    a: "Yes. You fully own the site, the domain, the content, and the hosting credentials. No proprietary platform lock-in, no holding your site hostage if you ever leave — that's the opposite of how we operate.",
  },
  {
    q: "What's the difference between a cheap website and one that actually generates leads?",
    a: "A cheap site is a brochure — pretty, maybe, but built without conversion strategy, page speed, mobile UX, or SEO. A lead-generating site is engineered around how Colorado customers actually search, click, and call. The first costs you future jobs; the second pays for itself in 60–90 days.",
  },
];

export const Route = createFileRoute("/contractor-web-design-colorado")({
  head: () =>
    industryMarketingHead(
      "Contractor Web Design",
      "contractor",
      "contractor-web-design-colorado",
      FAQS,
    ),
  component: () => (
    <IndustryMarketingPage
      industry="Contractor Web Design"
      industryLower="contractor"
      slug="contractor-web-design-colorado"
      subheadline="A contractor website that actually wins you jobs — not just a digital brochure."
      painPoints={[
        "Current website looks unprofessional and loses bids before the estimate is even sent",
        "No clear call-to-action or lead form — visitors leave without ever contacting the business",
        "Mobile experience is broken and more than 70% of visitors are on their phones",
      ]}
      serviceDescriptions={{
        seo: "Local SEO baked into every page so contractors rank in their service-area cities.",
        googleMaps: "Map Pack rankings to capture nearby homeowners and commercial buyers.",
        webDesign: "Conversion-first contractor websites with clear CTAs, fast loads, and lead forms.",
        ppc: "Google Ads paired with conversion-tested landing pages to turn clicks into bids.",
        geoAi: "Make your contractor brand citable by ChatGPT, Gemini & Google AI Overviews.",
        socialMedia: "Jobsite photos and reviews that prove quality before the first call.",
      }}
      testimonial={{
        quote:
          "They get small business. They get Colorado. And they get results. Couldn't recommend them more.",
        role: "Cleaning Company Owner",
        city: "Fort Collins",
      }}
      faqs={FAQS}
      industrySpokes={[]}
      cityHubLinks={[
        {
          "to": "/colorado-springs",
          "label": "Contractor web design in Colorado Springs",
          "description": "Mobile-first websites for Springs general and specialty contractors."
        },
        {
          "to": "/denver-digital-marketing",
          "label": "Contractor web design in Denver",
          "description": "Conversion-focused contractor websites for the Denver metro."
        },
        {
          "to": "/fort-collins-digital-marketing",
          "label": "Contractor web design in Fort Collins",
          "description": "Northern Colorado contractor web design that ranks and converts."
        }
      ]}
    />
  ),
});
